module.exports = __webpack_public_path__ + "img/materials_box.331dbf7a.svg";